export default __webpack_public_path__ + "static/avatar-marcus-7f7259dcdc6be2f4df2ed82fef8cacde.png";